<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contatti</li>
            </ul>
            <h2>Contattaci</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div id="map">
    <iframe src="https://maps.google.com/maps?q=Campania%20Futura%20Srl,%20Napoli,%20NA%20Italia&t=k&z=19&ie=UTF8&iwloc=&output=embed"></iframe>
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Chi siamo</span>
                    <h2>Il Migliore Ente di Formazione Accreditato e Certificato</h2>
                    <p>
                        Il Centro Formazione Campania Futura, ente accreditato presso la Regione Campania, presso FON.D.ER (Fondo paritetico per la formazione continua nelle imprese del comparto Scuola e del comparto Socio - Sanitario - Assistenziale - Educativo) e presso FORMA.TEMP (Fondo per la formazione e il sostegno al reddito dei lavoratori in somministrazione), opera con esperienza consolidata dal 2013.
                    </p>
                   <p>
                        Ente di formazione impegnato nel sostegno e nella promozione di una visione ampia ed elevata della formazione professionale che tiene conto del cambiamento e delle trasformazioni della società e della comunità locale nella quale opera, aggiornando e programmando i propri corsi, in considerazione delle tendenze del mercato del lavoro territoriale e delle figure professionali più richieste.
                   </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">dalla formazione alla professione</span>
                    <h2>Cosa abbiamo di Speciale?</h2>
                    <p>
                        Docenti, tutor, progettisti, project management, esperti marketing cooperano e lavorano con determinazione e hanno creato negli anni, piani formativi di elevata qualità, in grado di fornire formazione di eccellenza e nel contempo elevate competenze professionali.
                    </p>
                   <p>
                        Campania Futura articola i propri corsi in diversi settori di attività interagendo con Aziende, Associazioni, Studi Professionali, Scuole ed Enti del territorio, con la precisa volontà di erogare azioni formative e di orientamento a servizio di giovani e adulti. Da sempre, persegue con particolare interesse, l'attivazione di percorsi integrati tra scuola, formazione e contesto produttivo.
                   </p>
                   <p>
                        Il team di Campania Futura è formato da giovani professionisti specializzati e competenti. Un gruppo affiatato, esperto ed eterogeneo che ha fatto del lavoro di squadra il proprio punto di forza, stabilisce insieme gli obiettivi di corsi e progetti, condivide idee, traguardi e successi.
                    </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Informazioni</span>
                    <h2>Mettiti in contatto</h2>
                    <p>Ci piace ascoltare i lettori. Apprezziamo davvero che tu abbia dedicato del tempo per metterci in contatto.</p>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>Sede Napoli</h3>
                            <p>Via Vicinale S. Maria del Pianto<br>
                                Centro Polifunzionale<br>Torre 5 – 10° piano<br>Napoli (NA)</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti (Sede Napoli)</h3>
                            <p>Telefono: <a href="tel:+39081281507">(+39) 081-281507</a></p>
                            <p>e-mail: <a href="mailto:campaniafutura@gmail.com">campaniafutura@gmail.com</a></p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>Sede Lioni</h3>
                            <p>Via Delle Città Gemellate, Snc<br>
                                83047 Lioni (Avellino)</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti (Sede Lioni)</h3>
                            <p>Mobile: <a href="tel:+393283584928">(+39) 328-3584928</a></p>
                            <p>Telefono: <a href="tel:+3908271830395">(+39) 0827-1830395</a></p>
                            <p>e-mail: <a href="mailto:campaniafutura.lioni@gmail.com">campaniafutura.lioni@gmail.com</a></p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <h3>Siamo disponibili</h3>
                            <p>Lunedì - Venerdì: 09:00 - 18:00</p>
                            <p>Sabato: 09:00 - 13:00</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
                    <h2>Come possiamo aiutarti?</h2>
                    <p>L'indirizzo email non verrà pubblicato. i campi richiesti sono contrassegnati dal simbolo*</p>
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Nome e Cognome">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Nome e Cognome richiesto.</div>
                                        <div *ngIf="name.errors.minlength">Numero minimo {{ name.errors.minlength.requiredLength }} di caratteri.</div>
                                        <div *ngIf="name.errors.maxlength">Numero massimo di 50 caratteri.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="la tua e-mail">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="cellulare">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">un contatto telefonico è obbligatorio</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5" class="form-control" placeholder="scrivi il tuo messaggio..."></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">il messaggio è obbligatorio</div>
                                </div>
                            </div>
                            <h2 class="mt-3">Quale corso sei interessato?</h2>
                            <p>seleziona il corso interessato alla quale vuoi avere informazioni*</p>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <select name="sceltaCorso" ngModel id="sceltaCorso" #sceltaCorso="ngModel" style="display: block;
                                    width: 100%;
                                    border: none;
                                    color: var(--blackColor);
                                    background-color: #F3F6F9;
                                    height: 50px;
                                    padding-left: 15px;
                                    border-radius: 5px;
                                    font-size: var(--fontSize);
                                    font-weight: 600">
                                        <option value="{{elencoCorsiRow['corso']['titolo']}}" *ngFor="let elencoCorsiRow of elencoCorsi">{{elencoCorsiRow['corso']['titolo']}}</option>
                                      </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 mt-3">
                                <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid">Invia Richiesta<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
